import * as React from 'react';

const SHOW_ALL_TABS: boolean = true;

interface ITabsProps {
  type?: string;
  tabs: string[];
  onChange?: (i: number) => void;
  children: any;
}

interface ITabsState {
  activeTab: number;
}

class Tabs extends React.Component<ITabsProps> {
  public state: ITabsState;

  constructor(props: ITabsProps) {
    super(props);

    this.state = {
      activeTab: 0
    };

    this.changeTab = this.changeTab.bind(this);
  }

  public changeTab(tab: number) {
    if (this.props.onChange) {
      this.props.onChange(tab);
    }
 
    this.setState({
      activeTab: tab
    });
  }

  public render() {
    const className: string = 'tabs';
    const { type, tabs, children } = this.props;

    let tabContent = children;

    if (!Array.isArray(tabContent)) {
      tabContent = [tabContent];
    }

    tabContent = tabContent.filter((t: any) => t !== null);

    return (
      <div className={className + (type ? ' ' + className + '--' + type : '')}>
        <div className="tabs__nav">
          {tabs.map((tab, i) => {
            return (
              <div
                key={i}
                className={'tabs__link' + (i === this.state.activeTab ? ' active' : '')}
                onClick={() => this.changeTab(i)}
              >
                {tab}
              </div>
            );
          })}
        </div>
        {SHOW_ALL_TABS
        ? tabContent.map((c: any, i: number) => (<div key={i} className={`tabs__content${this.state.activeTab !== i ? ' tabs__content__notShown' : ''}`}>
          {c}
        </div>))
        : <div className="tabs__content">
          {tabContent[this.state.activeTab]}
        </div>}
      </div>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/modules/Tabs/Tabs.tsx